import { SiteFiltersStore } from "../store";
import { sanitiseVueObservable } from "../../../helpers/sanitiseVueObservable";
import { useSnapshot } from "valtio";

export const useSiteLabels = (store: SiteFiltersStore) => {
  const { siteLabels } = useSnapshot(store);

  return sanitiseVueObservable(siteLabels) as string[];
};
